<div class="device-result-container">
  <app-device-info (onDeviceAddedOrRemoved)="onCompareDeviceUpdated(group)" [checkboxesAreDisabled]="checkboxesAreDisabled" [isDeviceBeingCompared]="group.isDeviceBeingCompared" [device]="group.primaryItem" [includeBottomBorderMobile]="group.secondaryItems.length > 0"></app-device-info>
  <!-- <div *ngIf="!showSecondaryDevices && group.secondaryItems.length > 0" class="secondary-devices-link-container">
    <button mat-button
            class="link secondary-devices-link"
            (click)="showSecondaryDevices = true">{{viewAdditionalOptionsButtonText}}</button>
  </div>
  <div *ngIf="showSecondaryDevices">
    <div class="secondary-devices-link-container">
      <button mat-button
              class="link secondary-devices-link"
              (click)="showSecondaryDevices = false">{{hideAdditionalOptionsButtonText}}</button>
    </div>
    <app-device-info *ngFor="let device of group.secondaryItems; let last = last" [device]="device" [includeBottomBorderMobile]="!last"></app-device-info>
  </div> -->
</div>
